import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  appServices = [
    { name: 'CRM', url: 'http://crm.akashicsoft.com/crm/auth?code=' + localStorage.getItem('code') },
    // { name: 'Helpdesk', url: 'http://localhost:4300/helpdesk/auth?code=' + localStorage.getItem('code') },
    { name: 'Chat', url: 'http://chat.akashicsoft.com?code=' + localStorage.getItem('code') },
  ];

  constructor() { }

  ngOnInit() {
  }

}
